export interface INotFoundPageProps {}

const NotFoundPage: React.FunctionComponent<INotFoundPageProps> = (props) => {
  return (
    <div className="see">
      <p>This is the not found page.</p>
    </div>
  );
};

export { NotFoundPage };
